import LookupControlBase from "components/controls/LookupControlBase";
import LookupControlDialog from "components/controls/LookupControlDialog";
import {
    account as IXrmTypes_account
} from 'model/CRM';
import {
    IEntityReferenceValue as FAM_IEntityReferenceValue
} from "model/FlexibleAttributeModel";
import React, { useEffect, useState } from "react";

interface IProps {
    onPick?: (value: FAM_IEntityReferenceValue | null) => void;
    onCancel?: () => void;
    searchOnMount?: boolean;
    searchStaged?: boolean;
    value: FAM_IEntityReferenceValue | null;
    account: IXrmTypes_account;
    required?: boolean;
    disabled?: boolean;
}


const OpportunityLookup: React.FC<IProps> = (props) => {
    const [opportunity, setOpportunity] = useState<FAM_IEntityReferenceValue | null>(null);

    const [searching, setSearching] = useState(false);
    const [query, setQuery] = useState<string>('');

    function onPick(value: FAM_IEntityReferenceValue | null) {
        const opportunity = value;
        setOpportunity(opportunity);
        props.onPick?.(value);
    }

    useEffect(() => {

        const viewSearchOpportunity = {
            "viewName": "Group Configuration for Properties",
            "entityName": "opportunity",
            "entitySetName": "opportunities",
            "fetchXML": "<fetch version=\"1.0\" output-format=\"xml-platform\" mapping=\"logical\" distinct=\"false\"><entity name=\"opportunity\"><attribute name=\"name\"/><attribute name=\"bcbs_opportunitytype\"/><attribute name=\"bcbs_opportunityshortname\"/><attribute name=\"estimatedclosedate\"/><attribute name=\"ownerid\"/><attribute name=\"statecode\"/><attribute name=\"opportunityid\"/><order attribute=\"estimatedclosedate\" descending=\"true\"/><filter type=\"and\"><condition attribute=\"statecode\" operator=\"in\"><value>0</value><value>1</value></condition><condition attribute=\"name\" operator=\"like\" value=\"%SEARCHVALUE%\"/><condition attribute=\"parentaccountid\" operator=\"eq\" value=\"{%AccountId%}\"/></filter></entity></fetch>",
            "layout": {
                "Name": "resultset",
                "Object": 3,
                "Rows": [
                    {
                        "Name": "result",
                        "Id": "opportunityid",
                        "Cells": [
                            {
                                "Name": "estimatedclosedate",
                                "Width": 100,
                                "RelatedEntityName": "",
                                "DisableMetaDataBinding": false,
                                "LabelId": "",
                                "IsHidden": false,
                                "DisableSorting": false,
                                "AddedBy": "",
                                "Desc": "",
                                "CellType": "",
                                "ImageProviderWebresource": "",
                                "ImageProviderFunctionName": "",
                                "DisplayName": "Effective Date",
                                "IsPrimaryId": false,
                                "AttributeType": "DateTime",
                                "IsPrimaryName": false
                            },
                            {
                                "Name": "name",
                                "Width": 300,
                                "RelatedEntityName": "",
                                "DisableMetaDataBinding": false,
                                "LabelId": "",
                                "IsHidden": false,
                                "DisableSorting": false,
                                "AddedBy": "",
                                "Desc": "",
                                "CellType": "",
                                "ImageProviderWebresource": "",
                                "ImageProviderFunctionName": "",
                                "DisplayName": "Topic",
                                "IsPrimaryId": false,
                                "AttributeType": "String",
                                "IsPrimaryName": true
                            },
                            {
                                "Name": "bcbs_opportunitytype",
                                "Width": 150,
                                "RelatedEntityName": "",
                                "DisableMetaDataBinding": false,
                                "LabelId": "",
                                "IsHidden": false,
                                "DisableSorting": false,
                                "AddedBy": "",
                                "Desc": "",
                                "CellType": "",
                                "ImageProviderWebresource": "",
                                "ImageProviderFunctionName": "",
                                "DisplayName": "Opportunity Type",
                                "IsPrimaryId": false,
                                "AttributeType": "Picklist",
                                "IsPrimaryName": false
                            },
                            {
                                "Name": "bcbs_opportunityshortname",
                                "Width": 300,
                                "RelatedEntityName": "",
                                "DisableMetaDataBinding": false,
                                "LabelId": "",
                                "IsHidden": false,
                                "DisableSorting": false,
                                "AddedBy": "",
                                "Desc": "",
                                "CellType": "",
                                "ImageProviderWebresource": "",
                                "ImageProviderFunctionName": "",
                                "DisplayName": "Opportunity Short Name",
                                "IsPrimaryId": false,
                                "AttributeType": "String",
                                "IsPrimaryName": false
                            },
                            {
                                "Name": "statecode",
                                "Width": 100,
                                "RelatedEntityName": "",
                                "DisableMetaDataBinding": false,
                                "LabelId": "",
                                "IsHidden": false,
                                "DisableSorting": false,
                                "AddedBy": "",
                                "Desc": "",
                                "CellType": "",
                                "ImageProviderWebresource": "",
                                "ImageProviderFunctionName": "",
                                "DisplayName": "Status",
                                "IsPrimaryId": false,
                                "AttributeType": "State",
                                "IsPrimaryName": false
                            },
                            {
                                "Name": "ownerid",
                                "Width": 300,
                                "RelatedEntityName": "",
                                "DisableMetaDataBinding": false,
                                "LabelId": "",
                                "IsHidden": false,
                                "DisableSorting": false,
                                "AddedBy": "",
                                "Desc": "",
                                "CellType": "",
                                "ImageProviderWebresource": "",
                                "ImageProviderFunctionName": "",
                                "DisplayName": "Owner",
                                "IsPrimaryId": false,
                                "AttributeType": "Owner",
                                "IsPrimaryName": false
                            }
                        ],
                        "MultiObjectIdField": "",
                        "LayoutStyle": ""
                    }
                ],
                "CustomControlDescriptions": [],
                "Jump": "name",
                "Select": true,
                "Icon": true,
                "Preview": true,
                "IconRenderer": ""
            }
        };

        let query = JSON.stringify(viewSearchOpportunity);

        if (props.account.accountid)
            query = query.replace('%AccountId%', props.account.accountid);

        setQuery(query);

    }, []);

    return <>
        <LookupControlBase
            label='Opportunity'
            required={props.required}
            value={props.value?.name ?? opportunity?.name ?? ''}
            valueEntityReference={props.value ?? opportunity ?? undefined}
            onLookup={() => {
                setSearching(true);
            }}
            onDelete={() => {
                onPick(null);
            }}
            disabled={props.disabled}
        />

        <LookupControlDialog
            isOpen={!!query && searching}
            label={'Opportunity'}
            variant={'single'}
            masterAttribute={{ bcbs_lookupviewdefinition: query }}
            onPick={(event) => {
                setSearching(false);

                if (event?.length === 1) {
                    onPick(event[0] as FAM_IEntityReferenceValue);
                }
            }}
            onCancel={() => {
                setSearching(false);
                props.onCancel?.();
            }}
            onDismiss={() => {
                setSearching(false);
                props.onCancel?.();
            }}
        />

    </>;
}
export default OpportunityLookup;